import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import H7 from 'UIComponents/elements/headings/H7';
import UIStepperInput from 'UIComponents/input/UIStepperInput';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIDropdownCaret from 'UIComponents/dropdown/UIDropdownCaret';
import { MIN_PROGRESS_FILTER_PERCENTAGE, ADS_MAX_GOAL_PROGRESS_PERCENTAGE } from 'AdsUI/lib/Goals';
export const ProgressSelectDownCaret = styled(UIDropdownCaret).withConfig({
  displayName: "GoalProgressFilter__ProgressSelectDownCaret",
  componentId: "t8n18o-0"
})(["margin-left:6px !important;"]);

const GoalProgressFilter = ({
  minProgress,
  maxProgress,
  onChangeProgress
}) => {
  const [progressFilterOpen, setProgressFilterOpen] = useState(false);
  const [localMinProgress, setLocalMinProgress] = useState(minProgress || MIN_PROGRESS_FILTER_PERCENTAGE);
  const [localMaxProgress, setLocalMaxProgress] = useState(maxProgress || ADS_MAX_GOAL_PROGRESS_PERCENTAGE);

  const submitProgressFilter = () => {
    onChangeProgress(localMinProgress, localMaxProgress);
    setProgressFilterOpen(false);
  };

  const clearProgressFilter = () => {
    setLocalMinProgress(MIN_PROGRESS_FILTER_PERCENTAGE);
    setLocalMaxProgress(ADS_MAX_GOAL_PROGRESS_PERCENTAGE);
    onChangeProgress(null, null);
    setProgressFilterOpen(false);
  };

  const ProgressFilters = () => {
    return /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      children: [/*#__PURE__*/_jsx(UIStepperInput, {
        className: "m-right-2",
        min: MIN_PROGRESS_FILTER_PERCENTAGE,
        stepSize: 1,
        style: {
          width: 100
        },
        value: localMinProgress,
        onChange: event => setLocalMinProgress(Number(event.target.value))
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "goalsDashboard.progressFilter.to"
      }), /*#__PURE__*/_jsx(UIStepperInput, {
        className: "m-left-2",
        min: localMinProgress,
        stepSize: 1,
        style: {
          width: 100
        },
        value: localMaxProgress,
        onChange: event => setLocalMaxProgress(Number(event.target.value))
      })]
    });
  };

  const defaultProgressSelected = minProgress === null || maxProgress === null;
  return /*#__PURE__*/_jsxs("span", {
    className: "align-center",
    children: [/*#__PURE__*/_jsx("div", {
      className: "m-right-1",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "goalsDashboard.progressFilter.label"
      })
    }), /*#__PURE__*/_jsx(UIPopover, {
      content: {
        header: /*#__PURE__*/_jsx(H7, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "goalsDashboard.progressFilter.viewByRange"
          })
        }),
        body: ProgressFilters(),
        footer: /*#__PURE__*/_jsxs(UIButtonWrapper, {
          justify: "between",
          children: [/*#__PURE__*/_jsx(UIButton, {
            size: "sm",
            use: "tertiary",
            onClick: submitProgressFilter,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "goalsDashboard.progressFilter.apply"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            size: "sm",
            use: "tertiary-light",
            onClick: clearProgressFilter,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "goalsDashboard.progressFilter.reset"
            })
          })]
        })
      },
      open: progressFilterOpen,
      placement: "bottom",
      onOpenChange: event => {
        return setProgressFilterOpen(event.target.value);
      },
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "filter-percent-progress",
        use: "transparent",
        onClick: () => {
          return setProgressFilterOpen(!progressFilterOpen);
        },
        children: /*#__PURE__*/_jsxs("span", {
          className: "display-flex",
          children: [defaultProgressSelected ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "goalsDashboard.progressFilter.any"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "goalsDashboard.progressFilter.button",
            options: {
              maxProgress,
              minProgress
            }
          }), /*#__PURE__*/_jsx(ProgressSelectDownCaret, {})]
        })
      })
    })]
  });
};

export default GoalProgressFilter;